import React from 'react'
import ReactDOM from 'react-dom/client'

import get from 'lodash/get'

import classNames from 'classnames'

import styles from '../index.module.sass'

import Header from '../components/site/header'

const globalData = JSON.parse(document.getElementById('global-data').innerHTML)
const navData = JSON.parse(document.getElementById('nav-data').innerHTML)
const pageData = JSON.parse(document.getElementById('page-data').innerHTML)
const root = ReactDOM.createRoot(document.getElementById("root-header"))

function App({pageData, navData, globalData}) {
	
	const headerStyle = get(pageData, 'page_settings.header_style')

	return <div className={classNames(styles.app, styles[`header_${headerStyle}`])}>
		<Header />
	</div>
}

root.render(
	<React.StrictMode>
		<App pageData={pageData} navData={navData} globalData={globalData} />
	</React.StrictMode>
)